import { normalizeInvitationEmail } from "../collections/invitations";

export type AccountInvitationLink = {
  accountId: string;
  email: string;
};

export function parseAccountInvitationSearch(
  search: string
): AccountInvitationLink | null {
  const params = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search
  );
  const accountId = params.get("accountId")?.trim() ?? "";
  const email = normalizeInvitationEmail(params.get("email") ?? "");
  if (!accountId || !email.includes("@")) {
    return null;
  }
  return { accountId, email };
}

export type InvitationEmailMatch =
  | { kind: "match" }
  | { kind: "missing-auth-email" }
  | { kind: "mismatch"; authEmail: string; invitedEmail: string };

export function matchInvitationEmail(
  authEmail: string | null | undefined,
  invitedEmail: string
): InvitationEmailMatch {
  const invited = normalizeInvitationEmail(invitedEmail);
  const rawAuth = authEmail?.trim() ?? "";
  if (!rawAuth) {
    return { kind: "missing-auth-email" };
  }
  if (normalizeInvitationEmail(rawAuth) === invited) {
    return { kind: "match" };
  }
  return { kind: "mismatch", authEmail: rawAuth, invitedEmail: invited };
}
